import { Badge } from "@/components/ui";
import { TooltipWrapper } from "@/components/ui/shadcn/Tooltip/TooltipWrapper";
import { cn } from "@/lib/utils/cn";
import { type CellContext, type Row } from "@tanstack/react-table";
import dayjs from "dayjs";
import { isNil } from "lodash";
import { CheckIcon, XIcon } from "lucide-react";

export const customDateTimeSortingFns = {
  customDateTime: (
    rowA: Row<unknown>,
    rowB: Row<unknown>,
    columnId: string,
  ) => {
    if (isNil(rowA.getValue(columnId))) {
      return 1;
    }
    if (isNil(rowB.getValue(columnId))) {
      return -1;
    }
    return dayjs(rowA.getValue(columnId)).diff(dayjs(rowB.getValue(columnId)));
  },
};

export function renderCheckedCell<T>({
  props,
  showX,
}: {
  props: CellContext<T, unknown>;
  showX?: boolean;
}) {
  const value = props.getValue();
  return (
    <div className="flex space-x-2">
      {value ? (
        <CheckIcon className="h-5 w-5 text-green-500" />
      ) : showX ? (
        <XIcon className="h-5 w-5 text-red-500" />
      ) : (
        "-"
      )}
    </div>
  );
}

export const MultiValueCell = ({
  value,
  showItemCount = 1,
  badgeClassName,
  includeFirstItemInTooltip = false,
}: {
  value?: string[] | [];
  showItemCount?: number;
  badgeClassName?: string;
  includeFirstItemInTooltip?: boolean;
}) => {
  if (!value || value.length === 0) {
    return "-";
  }
  const firstString =
    value.length > showItemCount ? value.slice(0, showItemCount) : value;
  const othersString = value.slice(showItemCount);
  return (
    <div>
      <TooltipWrapper
        message={
          othersString.length > 0
            ? (includeFirstItemInTooltip ? value : othersString).join("\n ")
            : ""
        }
      >
        <div className="flex max-w-full min-w-0 items-center">
          <span className="truncate" title={firstString.join(", ")}>
            {firstString.join(", ")}
          </span>
          {othersString.length ? (
            <span className="ml-2 shrink-0">
              <Badge className={cn("h-4", badgeClassName)}>
                +{othersString.length}
              </Badge>
            </span>
          ) : null}
        </div>
      </TooltipWrapper>
    </div>
  );
};
